import { useEffect, useId, useRef } from 'react'
import styles from './MascotGame.module.css'

export function GameConfirm({
  title,
  description,
  leaveLabel,
  onContinue,
  onLeave,
}: {
  title: string
  description: string
  leaveLabel: string
  onContinue: () => void
  onLeave: () => void
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  const id = useId()
  useEffect(() => {
    const element = dialog.current
    const previous =
      document.activeElement instanceof HTMLElement ? document.activeElement : null
    element?.showModal()
    return () => {
      element?.close()
      previous?.focus()
    }
  }, [])
  return (
    <dialog
      ref={dialog}
      className={styles.confirmDialog}
      role="alertdialog"
      aria-labelledby={id}
      onCancel={(event) => {
        event.preventDefault()
        event.stopPropagation()
        onContinue()
      }}
    >
      <h2 id={id}>{title}</h2>
      <p>{description}</p>
      <button className={styles.primaryButton} onClick={onContinue} autoFocus>
        Continuar aqui
      </button>
      <button className={styles.secondaryButton} onClick={onLeave}>
        {leaveLabel}
      </button>
    </dialog>
  )
}
